<onyx-modal
  variant="center"
  [heading]="`${I18N}.editPayment`"
  [close$]="close$"
  (closeModal)="dialogRef.close($event)"
>
  <app-order-modal-payment-form
    [order]="data.order"
    [form]="form"
    [mode]="OnyxFormMode.EDIT"
  ></app-order-modal-payment-form>

  <onyx-button
    bottomLeftOptions
    variant="outlined"
    color="red"
    (click)="deletePayment()"
  >
    {{ 'labels.delete' | translate }}
  </onyx-button>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button [spinner]="loading()" (click)="!loading() ? submit() : null">
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
